import { Fragment } from "react";

function ShowMoreButton({ currentMaxItems, totalCount, onClick }) {
  if (currentMaxItems >= totalCount) {
    return null;
  }

  return (
    <Fragment>
      <br />
      <div className="text-center">
        <a className="btn btn-primary" onClick={onClick}>
          Load more
          <i className="las la-angle-right la-4" aria-hidden="true" />
        </a>
      </div>
    </Fragment>
  );
}

export default ShowMoreButton;
